import React from 'react';
import { useTranslation } from 'react-i18next';
import { PenEdit16 } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';
import {
  MetaViewOptions,
  useOpenTaskDetail,
} from 'shared/contexts/task-detail';
import { Task } from 'shared/types/task';
import { TaskType } from 'shared/types/task-base';
import { focusOnEndOfEditableContent } from 'shared/utils/focus-on-end-of-element';

export type EditListProps = {
  task: Task;
  onClose: () => void;
  nameRef?: React.RefObject<HTMLSpanElement>;
};

export const EditList: React.FC<EditListProps> = ({
  task,
  onClose,
  nameRef,
}) => {
  const { t } = useTranslation();
  const openTaskDetail = useOpenTaskDetail();

  const onEdit = () => {
    openTaskDetail(
      task,
      task.type === TaskType.Habit
        ? MetaViewOptions.Statistics
        : MetaViewOptions.Settings,
    );

    if (nameRef?.current) {
      focusOnEndOfEditableContent(nameRef.current);
    }

    onClose();
  };

  return (
    <PopupMenuList hasBottomBorder>
      <PopupMenuListItem>
        <PopupMenuButton onClick={onEdit} start={<Icon icon={PenEdit16} />}>
          {t('context-menus.task.labels.edit')}
        </PopupMenuButton>
      </PopupMenuListItem>
    </PopupMenuList>
  );
};
